import { render, staticRenderFns } from "./CatProductos.vue?vue&type=template&id=1aef4d49"
import script from "./CatProductos.vue?vue&type=script&lang=js"
export * from "./CatProductos.vue?vue&type=script&lang=js"
import style0 from "./CatProductos.vue?vue&type=style&index=0&id=1aef4d49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports